// extracted by mini-css-extract-plugin
export default {"star":"StarsRate_star__HOHnu","rateStar":"StarsRate_rateStar__h+z81"};